import { useState } from 'react';
import type { ExecuteOnUcUiChangeProps } from '../loadingUCUI';
import { executeOnUcUiChange } from '../loadingUCUI';
import type { UC_UI_Props } from '../types';

export const showSecondLayer: UC_UI_Props['showSecondLayer'] = (props) => {
    window.UC_UI?.showSecondLayer(props);
};

export const isInitialized: UC_UI_Props['isInitialized'] = () => {
    const [isSuccessfullyInitialized, setIsSuccessfullyInitialized] = useState(false);
    const executeProps: ExecuteOnUcUiChangeProps = {
        onSuccess: () => {
            setIsSuccessfullyInitialized(true);
        }
    };
    executeOnUcUiChange(executeProps);
    return isSuccessfullyInitialized;
};
